import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtractTasksMode } from '../../../ts/services/CreateExtractTasksAction';
import { CreateExtractRefresh } from '../AppActionTypes';

export interface CreateExtractRefreshAction extends Action {
  selectedContent: IContentInfo[];
  mode: CreateExtractTasksMode;
}

export function createExtractRefresh(
  selectedContent: IContentInfo[],
  mode: CreateExtractTasksMode
): CreateExtractRefreshAction {
  return {
    type: CreateExtractRefresh,
    selectedContent,
    mode,
  };
}
